"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _uiKit = require("@dbi-tools/ui-kit");

var _container = require("@dbi-tools/ui-kit/lib/components/container");

var _row = require("@dbi-tools/ui-kit/lib/components/row");

var _col = require("@dbi-tools/ui-kit/lib/components/col");

var _useStyles = require("../../hooks/useStyles");

var _const = require("../../const");

var _style = _interopRequireDefault(require("./style"));

var _const2 = require("./const");

var _quote = require("./quote.styled");

var _lazyLoadImage = require("../lazy-load-image");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Quote = function Quote(props) {
  var id = props.id,
      quote = props.quote,
      personName = props.personName,
      _props$align = props.align,
      align = _props$align === void 0 ? _const.Align.CENTER : _props$align,
      _props$size = props.size,
      size = _props$size === void 0 ? _const2.QuoteHeight.LARGE : _props$size,
      backgroundColor = props.backgroundColor,
      fileReference = props.fileReference,
      _props$theme = props.theme,
      currentTheme = _props$theme === void 0 ? _const2.QuoteTheme.WHITE : _props$theme,
      quotationMarksEnabled = props.quotationMarksEnabled,
      altText = props.backgroundImageAltText; // TODO move to some getIndent func and replace in all components

  var textColor = _const2.quoteThemeStrategy[currentTheme].textColor;
  var backgroundImage = fileReference;
  var isLargeBlock = size === _const2.QuoteHeight.LARGE;
  var isBackgroundOn = backgroundColor !== 'transparent';
  var padding = isLargeBlock ? 30 : 15;
  var basicStyles = isLargeBlock ? (0, _useStyles.useStyles)('a', _style.default) : (0, _useStyles.useStyles)('b', _style.default);
  var theme = {
    $theme: currentTheme,
    $styles: basicStyles
  };

  if (!quote && !personName) {
    return /*#__PURE__*/_react.default.createElement(_uiKit.Heading, {
      align: "center",
      as: "h2",
      fontWeight: "bold",
      measure: "h1"
    }, "Please configure QUOTE component");
  } // TODO merge quote + promo


  return /*#__PURE__*/_react.default.createElement(_uiKit.ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/_react.default.createElement(_quote.StyledBox, {
    p: [padding, 0],
    "data-test": _const.TestType.COMPONENT,
    "data-test-id": _const.TestValue.AEM_QUOTE,
    id: id
  }, backgroundImage && /*#__PURE__*/_react.default.createElement(_lazyLoadImage.LazyLoadImage, {
    src: backgroundImage,
    alt: altText,
    fit: "cover"
  }), /*#__PURE__*/_react.default.createElement(_container.Container, null, /*#__PURE__*/_react.default.createElement(_row.Row, {
    justifyContent: _const2.justifyContentStrategy[align]
  }, /*#__PURE__*/_react.default.createElement(_col.Col, {
    lg: 8,
    md: 9,
    xs: 12
  }, /*#__PURE__*/_react.default.createElement(_quote.QuoteStyled, {
    alignItems: _const2.alignItemsStrategy[align],
    height: _const2.quoteHeightStrategy[size] - padding * 2,
    isBackgroundOn: isBackgroundOn,
    bg: backgroundColor,
    colorContrast: _const.colorBlackOrWhite[backgroundColor]
  }, quote && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, quotationMarksEnabled && /*#__PURE__*/_react.default.createElement(_quote.HeadStyled, {
    align: align,
    color: textColor
  }, "\u201C"), /*#__PURE__*/_react.default.createElement(_quote.HeadStyled, {
    align: align,
    color: textColor,
    dangerouslySetInnerHTML: {
      __html: quote
    }
  })), personName && /*#__PURE__*/_react.default.createElement(_quote.ScriptStyled, {
    align: align,
    color: textColor
  }, personName)))))));
};

var _default = Quote;
exports.default = _default;